export default {
    products: state => state.products,
    purchasesModel: state => state.purchasesModel,
    loading: state => state.loading,
}